import {
  GridColumnVisibilityModel,
  GridFilterModel,
  GridSortModel,
} from '@mui/x-data-grid'
import { AxiosError } from 'axios'
import crypto from 'crypto'
import clone from 'just-clone'
import { ThunkAction } from 'redux-thunk'
import {
  CabPropsType,
  CabType,
  CabinetSizesSubType,
  CabinetSizesType,
  CategoryPropsType,
  CategoryType,
  CornerCabinetSizesSubType,
  CornerCabinetSizesType,
  CostumerPropsType,
  CostumerType,
  DiscountTierPropsType,
  DiscountTierType,
  FloorMaterialPropsType,
  FloorMaterialType,
  RecoveryCodeType,
  UserInfoType,
  UserType,
  addCabinetToDB,
  addCategoryToDB,
  addCostumerToDB,
  addDiscountTierToDB,
  addFloorMaterialToDB,
  createUser,
  deleteCabinetFromDB,
  deleteCategoryFromDB,
  deleteCostumerFromDB,
  deleteDiscountTierFromDB,
  editCabinetInDB,
  editCabinetSizesInDB,
  editCategoryInDB,
  editCompanyMarkupsAPI,
  editCompanyOptionsAPI,
  editConfigInDB,
  editCostumerInDB,
  editDiscountTierInDB,
  editFloorMaterialInDB,
  editUserAPI,
  fetchAllCabinets,
  fetchAllCostumers,
  fetchCabinetSizes,
  fetchCategories,
  fetchCompanyInfo,
  fetchCompanyUsersEmails,
  fetchCompanyUsersInfo,
  fetchConfigs,
  fetchCostumers,
  fetchDiscountTiers,
  fetchFloorMaterials,
  fetchRecoveryCodes,
  fetchUserCabinets,
  fetchUsersInfo,
  generateRecoveryCodeApi,
  getToken,
  logoutAPI,
  me,
  resetPasswordApi,
  setUserFieldAPI,
  setUserRoleAPI,
  shareCabinetInDB,
} from './../api/appAPI'
import {
  EnqueueSnackbarType,
  showMessage,
} from './../components/common/Helpers'
import * as allConfigs from './../config'
import { ConfigsType } from './../config'
import { InferActionsType, StateType } from './store'
import { getMaterials } from './itemReducer'
import { getRoleIndex } from '../common/helpers'

export type RoleType =
  | 'none'
  | 'dealer'
  | 'designer'
  | 'designer2'
  | 'engineer'
  | 'company'
  | 'admin'

export type GridStateType = {
  visibilityModel: GridColumnVisibilityModel | undefined
  sortModel: GridSortModel | undefined
  filterModel: GridFilterModel | undefined
}

const { appConfig, ...configs } = allConfigs

export type CompanyType = {
  name: string
  ownerName: string
  ownerId: number
  email: string
  logoURL: string
  options: string
}

export type ConfigDescriptionType = {
  name: string
  description: string
}

const initState = {
  isGSH: false,
  isDataFetched: false,
  windowSize: {
    width: 0,
    height: 0,
  },
  configs: configs as ConfigsType,
  cabinetSizes: undefined as undefined | CabinetSizesType,
  cornerCabinetSizes: undefined as undefined | CornerCabinetSizesType,
  actualCabinetSizes: {
    width: { default: 50, values: [] },
    height: { default: 50, values: [] },
    depth: { default: 50, values: [] },
  } as CabinetSizesSubType,
  actualCornerCabinetSizes: {
    width1: { default: 50, values: [] },
    width2: { default: 50, values: [] },
    height: { default: 50, values: [] },
    backWidth1: { default: 50, values: [] },
    backWidth2: { default: 50, values: [] },
    depth1: { default: 50, values: [] },
    depth2: { default: 50, values: [] },
  } as CornerCabinetSizesSubType,
  configsDescriptions: [] as ConfigDescriptionType[],
  isConfigsFetched: false,
  user: undefined as undefined | UserType,
  company: (localStorage.getItem('company')
    ? JSON.parse(localStorage.getItem('company') || '')
    : undefined) as undefined | CompanyType,
  isCompanyInfoFetched: false,
  token: undefined as undefined | string,
  usersInfo: [] as UserInfoType[],
  isDemo: false,
  // role: 'admin' as RoleType,
  sidebarHeight: 0,
  isSidebarOpen: false,
  dToolMode: false,
  hardwareGrid: localStorage.getItem('hardwareGridState')
    ? (JSON.parse(
        localStorage.getItem('hardwareGridState') || ''
      ) as GridStateType)
    : ({
        visibilityModel: {
          id: false,
          date: true,
          name: true,
          type: true,
          description: false,
          unitPrice: true,
          markup: true,
          materialBased: true,
          materialIds: false,
          defaultMaterialId: false,
          children: false,
          actions: true,
        },
        sortModel: undefined,
        filterModel: undefined,
      } as GridStateType),
  materialGrid: localStorage.getItem('materialGridState')
    ? (JSON.parse(
        localStorage.getItem('materialGridState') || ''
      ) as GridStateType)
    : ({
        visibilityModel: {
          id: false,
          date: true,
          name: true,
          type: true,
          cab: true,
          door: true,
          price: true,
          addon: false,
          texture: false,
          length: false,
          width: false,
          retail: false,
          dealer: false,
          designer: false,
          actions: true,
        },
        sortModel: undefined,
        filterModel: undefined,
      } as GridStateType),
  materialGroupGrid: localStorage.getItem('materialGroupGridState')
    ? (JSON.parse(
        localStorage.getItem('materialGroupGridState') || ''
      ) as GridStateType)
    : ({
        visibilityModel: {
          id: false,
          date: true,
          name: true,
          materialsIds: true,
          actions: true,
        },
        sortModel: undefined,
        filterModel: undefined,
      } as GridStateType),
  usersInfoGrid: localStorage.getItem('usersInfoGridState')
    ? (JSON.parse(
        localStorage.getItem('usersInfoGridState') || ''
      ) as GridStateType)
    : ({
        visibilityModel: {
          id: true,
          email: true,
          name: true,
          role: true,
          offerMarkups: true,
          refEmail: true,
        },
        sortModel: undefined,
        filterModel: undefined,
      } as GridStateType),
  userCabinetsGrid: localStorage.getItem('userCabinetsGridState')
    ? (JSON.parse(
        localStorage.getItem('userCabinetsGridState') || ''
      ) as GridStateType)
    : ({
        visibilityModel: {
          id: false,
          date: true,
          image: true,
          title: true,
          name: true,
          additional: false,
          type: true,
          categoryName: true,
          microvellumName: true,
          width: true,
          height: true,
          depth: true,
          sectionsCount: false,
          doorsCount: true,
          drawersCount: false,
        },
        sortModel: undefined,
        filterModel: undefined,
      } as GridStateType),
  categoryGrid: localStorage.getItem('categoryGridState')
    ? (JSON.parse(
        localStorage.getItem('categoryGridState') || ''
      ) as GridStateType)
    : ({
        visibilityModel: {
          id: true,
          date: true,
          name: true,
          forCorner: true,
          retailWidthValues: true,
          retailWidthDefault: true,
          retailHeightValues: false,
          retailHeightDefault: true,
          retailDepthValues: false,
          retailDepthDefault: true,
          dealerWidthValues: false,
          dealerWidthDefault: false,
          dealerHeightValues: false,
          dealerHeightDefault: false,
          dealerDepthValues: false,
          dealerDepthDefault: false,
          designerWidthValues: false,
          designerWidthDefault: false,
          designerHeightValues: false,
          designerHeightDefault: false,
          designerDepthValues: false,
          designerDepthDefault: false,
        },
        sortModel: undefined,
        filterModel: undefined,
      } as GridStateType),
  costumerGrid: localStorage.getItem('costumerGridState')
    ? (JSON.parse(
        localStorage.getItem('costumerGridState') || ''
      ) as GridStateType)
    : ({
        visibilityModel: {
          id: true,
          date: true,
          name: true,
          email: true,
          phone: true,
          address1: true,
          address2: true,
          zip: true,
          city: true,
          province: true,
          creatorEmail: true,
          companyEmail: true,
        },
        sortModel: undefined,
        filterModel: undefined,
      } as GridStateType),
  floorMaterialGrid: localStorage.getItem('floorMaterialGridState')
    ? (JSON.parse(
        localStorage.getItem('floorMaterialGridState') || ''
      ) as GridStateType)
    : ({
        visibilityModel: {
          id: false,
          date: true,
          name: true,
          sku: true,
          dealerId: true,
          floorSetupCharge: true,
          floorPricePerSqFt: true,
          curbSetupCharge: true,
          curbPricePerSqFt: true,
          curbLinearPricePerFt: true,
          shortDescription: true,
        },
        sortModel: undefined,
        filterModel: undefined,
      } as GridStateType),
  activeTab: appConfig.startTabNumber,
  activeAdminTab: appConfig.startAdminTabNumber,
  activeHardwareId: 0,
  activeMaterialId: 0,
  activeMaterialGroupId: 0,
  activeCategoryId: 0,
  gcInfo: {
    hash: '',
    cabinet: '',
    domain: '',
  },
  isInIframe: false,
  isFirstLoadIframe: true,
  userCabinetsList: [] as CabType[],
  allCabinetsList: [] as CabType[],
  actualCabinetTitle: '',
  availableUsersEmails: [] as string[],
  categoriesList: [] as CategoryType[],
  actualCabinetCategory: undefined as CategoryType | undefined,
  microvellumName: '',
  costumersList: [] as CostumerType[],
  floorMaterialsList: [] as FloorMaterialType[],
  recoveryCodes: [] as RecoveryCodeType[],
  fmTabAvailable: false,
  discountTiersList: [] as DiscountTierType[],
}

type InitStateType = typeof initState

const appReducer = (state = initState, action: ActionsType): InitStateType => {
  switch (action.type) {
    case 'cc/app/SET_IS_GSH':
      return {
        ...state,
        isGSH: action.value,
      }
    case 'cc/app/SET_IS_DATA_FETCHED':
      return {
        ...state,
        isDataFetched: action.value,
      }
    case 'cc/app/SET_SIDEBAR_HEIGHT':
      return {
        ...state,
        sidebarHeight: action.value,
      }
    case 'cc/app/SET_USER':
      return {
        ...state,
        user: action.value,
      }
    case 'cc/app/SET_COMPANY':
      if (action.value)
        localStorage.setItem('company', JSON.stringify(action.value))
      else localStorage.removeItem('company')

      return {
        ...state,
        company: action.value,
      }
    case 'cc/app/SET_TOKEN':
      if (action.value === undefined) localStorage.removeItem('sceneID')
      else localStorage.setItem('sceneID', action.value)
      return {
        ...state,
        token: action.value,
      }
    case 'cc/app/SET_ID_DEMO':
      return {
        ...state,
        isDemo: action.value,
      }
    // case 'cc/app/SET_ROLE':
    //     return {
    //         ...state,
    //         role: action.value
    //     }
    case 'cc/app/SET_USERS_INFO':
      return {
        ...state,
        usersInfo: action.arr,
      }
    case 'cc/app/SET_IS_SIDEBAR_OPEN':
      return {
        ...state,
        isSidebarOpen: action.value,
      }
    case 'cc/app/SET_WINDOW_SIZE':
      return {
        ...state,
        windowSize: { width: action.width, height: action.height },
      }
    case 'cc/app/SWITCH_DTOOL_MODE':
      return {
        ...state,
        dToolMode: !state.dToolMode,
      }
    case 'cc/app/SET_HARDWARE_GRID_VISIBILITY_MODEL': {
      return {
        ...state,
        hardwareGrid: {
          ...state.hardwareGrid,
          visibilityModel: action.model,
        },
      }
    }
    case 'cc/app/SET_HARDWARE_GRID_SORT_MODEL': {
      return {
        ...state,
        hardwareGrid: {
          ...state.hardwareGrid,
          sortModel: action.model,
        },
      }
    }
    case 'cc/app/SET_HARDWARE_GRID_FILTER_MODEL': {
      return {
        ...state,
        hardwareGrid: {
          ...state.hardwareGrid,
          filterModel: action.model,
        },
      }
    }
    case 'cc/app/SET_MATERIAL_GRID_VISIBILITY_MODEL': {
      return {
        ...state,
        materialGrid: {
          ...state.materialGrid,
          visibilityModel: action.model,
        },
      }
    }
    case 'cc/app/SET_MATERIAL_GRID_SORT_MODEL': {
      return {
        ...state,
        materialGrid: {
          ...state.materialGrid,
          sortModel: action.model,
        },
      }
    }
    case 'cc/app/SET_MATERIAL_GRID_FILTER_MODEL': {
      return {
        ...state,
        materialGrid: {
          ...state.materialGrid,
          filterModel: action.model,
        },
      }
    }
    case 'cc/app/SET_MATERIAL_GROUP_GRID_VISIBILITY_MODEL': {
      return {
        ...state,
        materialGroupGrid: {
          ...state.materialGroupGrid,
          visibilityModel: action.model,
        },
      }
    }
    case 'cc/app/SET_MATERIAL_GROUP_GRID_SORT_MODEL': {
      return {
        ...state,
        materialGroupGrid: {
          ...state.materialGroupGrid,
          sortModel: action.model,
        },
      }
    }
    case 'cc/app/SET_MATERIAL_GROUP_GRID_FILTER_MODEL': {
      return {
        ...state,
        materialGroupGrid: {
          ...state.materialGroupGrid,
          filterModel: action.model,
        },
      }
    }
    case 'cc/app/SET_USERS_INFO_GRID_VISIBILITY_MODEL': {
      return {
        ...state,
        usersInfoGrid: {
          ...state.usersInfoGrid,
          visibilityModel: action.model,
        },
      }
    }
    case 'cc/app/SET_USERS_INFO_GRID_SORT_MODEL': {
      return {
        ...state,
        usersInfoGrid: {
          ...state.usersInfoGrid,
          sortModel: action.model,
        },
      }
    }
    case 'cc/app/SET_USERS_INFO_GRID_FILTER_MODEL': {
      return {
        ...state,
        usersInfoGrid: {
          ...state.usersInfoGrid,
          filterModel: action.model,
        },
      }
    }
    case 'cc/app/SET_ACTIVE_TAB': {
      return {
        ...state,
        activeTab: action.value,
      }
    }
    case 'cc/app/SET_ADMIN_ACTIVE_TAB': {
      return {
        ...state,
        activeAdminTab: action.value,
      }
    }
    case 'cc/app/SET_ACTIVE_HARDWARE_ID': {
      return {
        ...state,
        activeHardwareId: action.value,
      }
    }
    case 'cc/app/OPEN_HARDWARE_DETAILS': {
      const user = state.user
      if (!user || (user && user.role !== 'admin')) {
        return state
      }

      return {
        ...state,
        activeTab: 2,
        activeHardwareId: action.hId,
      }
    }
    case 'cc/app/SET_ACTIVE_MATERIAL_ID': {
      return {
        ...state,
        activeMaterialId: action.value,
      }
    }
    case 'cc/app/OPEN_MATERIAL_DETAILS': {
      const user = state.user
      if (!user || (user && user.role !== 'admin')) {
        return state
      }

      return {
        ...state,
        activeTab: 3,
        activeMaterialId: action.id,
      }
    }
    case 'cc/app/SET_ACTIVE_MATERIAL_GROUP_ID': {
      return {
        ...state,
        activeMaterialGroupId: action.value,
      }
    }
    case 'cc/app/SET_ACTIVE_CATEGORY_ID': {
      return {
        ...state,
        activeCategoryId: action.value,
      }
    }
    case 'cc/app/OPEN_MATERIAL_GROUP_DETAILS': {
      return {
        ...state,
        activeTab: 4,
        activeMaterialGroupId: action.id,
      }
    }
    case 'cc/app/SET_IS_COMPANY_INFO_FETCHED': {
      return {
        ...state,
        isCompanyInfoFetched: action.value,
      }
    }
    case 'cc/app/SET_CONFIGS': {
      return {
        ...state,
        configs: action.configs,
      }
    }
    case 'cc/app/SET_CABINET_SIZES': {
      return {
        ...state,
        cabinetSizes: action.cabinetSizes,
      }
    }
    case 'cc/app/SET_CORNER_CABINET_SIZES': {
      return {
        ...state,
        cornerCabinetSizes: action.cabinetSizes,
      }
    }
    case 'cc/app/SET_ACTUAL_CABINET_SIZES': {
      return {
        ...state,
        actualCabinetSizes: action.cabinetSizes,
      }
    }
    case 'cc/app/SET_ACTUAL_CORNER_CABINET_SIZES': {
      return {
        ...state,
        actualCornerCabinetSizes: action.cabinetSizes,
      }
    }
    case 'cc/app/SET_IS_CONFIGS_FETCHED': {
      return {
        ...state,
        isConfigsFetched: action.value,
      }
    }
    case 'cc/app/SET_CONFIGS_DESCRIPTIONS': {
      return {
        ...state,
        configsDescriptions: action.arr,
      }
    }
    case 'cc/app/SET_GC_INFO': {
      return {
        ...state,
        gcInfo: {
          hash: action.hash,
          cabinet: action.cabinet,
          domain: action.domain,
        },
      }
    }
    case 'cc/app/SET_IS_IN_IFRAME': {
      return {
        ...state,
        isInIframe: action.value,
      }
    }
    case 'cc/app/SET_IS_FIRST_LOAD_IFRAME': {
      return {
        ...state,
        isFirstLoadIframe: action.value,
      }
    }
    case 'cc/app/SET_USER_CABINETS':
      return {
        ...state,
        userCabinetsList: action.arr,
      }
    case 'cc/app/SET_ALL_CABINETS':
      return {
        ...state,
        allCabinetsList: action.arr,
      }
    case 'cc/app/SET_ACTUAL_CABINET_TITLE':
      return {
        ...state,
        actualCabinetTitle: action.value,
      }
    case 'cc/app/SET_USER_CABINETS_GRID_VISIBILITY_MODEL': {
      return {
        ...state,
        userCabinetsGrid: {
          ...state.userCabinetsGrid,
          visibilityModel: action.model,
        },
      }
    }
    case 'cc/app/SET_USER_CABINETS_GRID_SORT_MODEL': {
      return {
        ...state,
        userCabinetsGrid: {
          ...state.userCabinetsGrid,
          sortModel: action.model,
        },
      }
    }
    case 'cc/app/SET_USER_CABINETS_GRID_FILTER_MODEL': {
      return {
        ...state,
        userCabinetsGrid: {
          ...state.userCabinetsGrid,
          filterModel: action.model,
        },
      }
    }
    case 'cc/app/SET_AVAILABLE_USERS_EMAILS':
      return {
        ...state,
        availableUsersEmails: [...action.arr],
      }
    case 'cc/app/SET_CATEGORIES_LIST':
      return {
        ...state,
        categoriesList: [...action.arr],
      }
    case 'cc/app/SET_CATEGORY_GRID_VISIBILITY_MODEL': {
      return {
        ...state,
        categoryGrid: {
          ...state.categoryGrid,
          visibilityModel: action.model,
        },
      }
    }
    case 'cc/app/SET_CATEGORY_GRID_SORT_MODEL': {
      return {
        ...state,
        categoryGrid: {
          ...state.categoryGrid,
          sortModel: action.model,
        },
      }
    }
    case 'cc/app/SET_CATEGORY_GRID_FILTER_MODEL': {
      return {
        ...state,
        categoryGrid: {
          ...state.categoryGrid,
          filterModel: action.model,
        },
      }
    }
    case 'cc/app/SET_ACTUAL_CABINET_CATEGORY':
      return {
        ...state,
        actualCabinetCategory: action.value,
      }
    case 'cc/app/SET_MICROVELLUM_NAME':
      return {
        ...state,
        microvellumName: action.value,
      }
    case 'cc/app/SET_COSTUMERS_LIST':
      return {
        ...state,
        costumersList: [...action.arr],
      }
    case 'cc/app/SET_COSTUMER_GRID_VISIBILITY_MODEL': {
      return {
        ...state,
        costumerGrid: {
          ...state.costumerGrid,
          visibilityModel: action.model,
        },
      }
    }
    case 'cc/app/SET_COSTUMER_GRID_SORT_MODEL': {
      return {
        ...state,
        costumerGrid: {
          ...state.costumerGrid,
          sortModel: action.model,
        },
      }
    }
    case 'cc/app/SET_COSTUMER_GRID_FILTER_MODEL': {
      return {
        ...state,
        costumerGrid: {
          ...state.costumerGrid,
          filterModel: action.model,
        },
      }
    }
    case 'cc/app/SET_RECOVERY_CODES':
      return {
        ...state,
        recoveryCodes: action.arr,
      }
    case 'cc/app/SET_FLOOR_MATERIALS_LIST':
      return {
        ...state,
        floorMaterialsList: [...action.arr],
      }
    case 'cc/app/SET_FLOOR_MATERIAL_GRID_VISIBILITY_MODEL': {
      return {
        ...state,
        floorMaterialGrid: {
          ...state.floorMaterialGrid,
          visibilityModel: action.model,
        },
      }
    }
    case 'cc/app/SET_FLOOR_MATERIAL_GRID_SORT_MODEL': {
      return {
        ...state,
        floorMaterialGrid: {
          ...state.floorMaterialGrid,
          sortModel: action.model,
        },
      }
    }
    case 'cc/app/SET_FLOOR_MATERIAL_GRID_FILTER_MODEL': {
      return {
        ...state,
        floorMaterialGrid: {
          ...state.floorMaterialGrid,
          filterModel: action.model,
        },
      }
    }
    case 'cc/app/SET_FM_TAB_AVAILABLE':
      return {
        ...state,
        fmTabAvailable: action.value,
      }
    case 'cc/app/SET_DISCOUNT_TIERS_LIST':
      return {
        ...state,
        discountTiersList: [...action.arr],
      }
    default:
      return state
  }
}

export const actions = {
  setIsGSH: (value: boolean) => ({ type: 'cc/app/SET_IS_GSH', value } as const),
  setIsDataFetched: (value: boolean) =>
    ({ type: 'cc/app/SET_IS_DATA_FETCHED', value } as const),
  setSidebarHeight: (value: number) =>
    ({ type: 'cc/app/SET_SIDEBAR_HEIGHT', value } as const),
  setUser: (value: undefined | UserType) =>
    ({ type: 'cc/app/SET_USER', value } as const),
  setToken: (value: undefined | string) =>
    ({ type: 'cc/app/SET_TOKEN', value } as const),
  setCompany: (value: undefined | CompanyType) =>
    ({ type: 'cc/app/SET_COMPANY', value } as const),
  setUsersInfo: (arr: UserInfoType[]) =>
    ({ type: 'cc/app/SET_USERS_INFO', arr } as const),
  setIsDemo: (value: boolean) =>
    ({ type: 'cc/app/SET_ID_DEMO', value } as const),
  setRole: (value: RoleType) => ({ type: 'cc/app/SET_ROLE', value } as const),
  setIsSidebarOpen: (value: boolean) =>
    ({ type: 'cc/app/SET_IS_SIDEBAR_OPEN', value } as const),
  setWindowSize: (width: number, height: number) =>
    ({ type: 'cc/app/SET_WINDOW_SIZE', width, height } as const),
  switchDToolMode: () => ({ type: 'cc/app/SWITCH_DTOOL_MODE' } as const),
  setHardwareGridVisibilityModel: (
    model: GridColumnVisibilityModel | undefined
  ) => ({ type: 'cc/app/SET_HARDWARE_GRID_VISIBILITY_MODEL', model } as const),
  setHardwareGridSortModel: (model: GridSortModel | undefined) =>
    ({ type: 'cc/app/SET_HARDWARE_GRID_SORT_MODEL', model } as const),
  setHardwareGridFilterModel: (model: GridFilterModel | undefined) =>
    ({ type: 'cc/app/SET_HARDWARE_GRID_FILTER_MODEL', model } as const),
  setMaterialGridVisibilityModel: (
    model: GridColumnVisibilityModel | undefined
  ) => ({ type: 'cc/app/SET_MATERIAL_GRID_VISIBILITY_MODEL', model } as const),
  setMaterialGridSortModel: (model: GridSortModel | undefined) =>
    ({ type: 'cc/app/SET_MATERIAL_GRID_SORT_MODEL', model } as const),
  setMaterialGridFilterModel: (model: GridFilterModel | undefined) =>
    ({ type: 'cc/app/SET_MATERIAL_GRID_FILTER_MODEL', model } as const),
  setMaterialGroupGridVisibilityModel: (
    model: GridColumnVisibilityModel | undefined
  ) =>
    ({
      type: 'cc/app/SET_MATERIAL_GROUP_GRID_VISIBILITY_MODEL',
      model,
    } as const),
  setMaterialGroupGridSortModel: (model: GridSortModel | undefined) =>
    ({ type: 'cc/app/SET_MATERIAL_GROUP_GRID_SORT_MODEL', model } as const),
  setMaterialGroupGridFilterModel: (model: GridFilterModel | undefined) =>
    ({ type: 'cc/app/SET_MATERIAL_GROUP_GRID_FILTER_MODEL', model } as const),
  setUsersInfoGridVisibilityModel: (
    model: GridColumnVisibilityModel | undefined
  ) =>
    ({ type: 'cc/app/SET_USERS_INFO_GRID_VISIBILITY_MODEL', model } as const),
  setUsersInfoGridSortModel: (model: GridSortModel | undefined) =>
    ({ type: 'cc/app/SET_USERS_INFO_GRID_SORT_MODEL', model } as const),
  setUsersInfoGridFilterModel: (model: GridFilterModel | undefined) =>
    ({ type: 'cc/app/SET_USERS_INFO_GRID_FILTER_MODEL', model } as const),
  setActiveTab: (value: number) =>
    ({ type: 'cc/app/SET_ACTIVE_TAB', value } as const),
  setAdminActiveTab: (value: number) =>
    ({ type: 'cc/app/SET_ADMIN_ACTIVE_TAB', value } as const),
  setActiveHardwareId: (value: number) =>
    ({ type: 'cc/app/SET_ACTIVE_HARDWARE_ID', value } as const),
  openHardwareDetails: (hId: number) =>
    ({ type: 'cc/app/OPEN_HARDWARE_DETAILS', hId } as const),
  setActiveMaterialId: (value: number) =>
    ({ type: 'cc/app/SET_ACTIVE_MATERIAL_ID', value } as const),
  openMaterialDetails: (id: number) =>
    ({ type: 'cc/app/OPEN_MATERIAL_DETAILS', id } as const),
  setActiveMaterialGroupId: (value: number) =>
    ({ type: 'cc/app/SET_ACTIVE_MATERIAL_GROUP_ID', value } as const),
  openMaterialGroupDetails: (id: number) =>
    ({ type: 'cc/app/OPEN_MATERIAL_GROUP_DETAILS', id } as const),
  setIsCompanyInfoFetched: (value: boolean) =>
    ({ type: 'cc/app/SET_IS_COMPANY_INFO_FETCHED', value } as const),
  setCabinetSizes: (cabinetSizes: CabinetSizesType) =>
    ({ type: 'cc/app/SET_CABINET_SIZES', cabinetSizes } as const),
  setCornerCabinetSizes: (cabinetSizes: CornerCabinetSizesType) =>
    ({ type: 'cc/app/SET_CORNER_CABINET_SIZES', cabinetSizes } as const),
  setActualCabinetSizes: (cabinetSizes: CabinetSizesSubType) =>
    ({ type: 'cc/app/SET_ACTUAL_CABINET_SIZES', cabinetSizes } as const),
  setActualCornerCabinetSizes: (cabinetSizes: CornerCabinetSizesSubType) =>
    ({ type: 'cc/app/SET_ACTUAL_CORNER_CABINET_SIZES', cabinetSizes } as const),
  setConfigs: (configs: ConfigsType) =>
    ({ type: 'cc/app/SET_CONFIGS', configs } as const),
  setIsConfigsFetched: (value: boolean) =>
    ({ type: 'cc/app/SET_IS_CONFIGS_FETCHED', value } as const),
  setConfigsDescriptions: (arr: ConfigDescriptionType[]) =>
    ({ type: 'cc/app/SET_CONFIGS_DESCRIPTIONS', arr } as const),
  setGCInfo: (hash: string, cabinet: string, domain: string) =>
    ({ type: 'cc/app/SET_GC_INFO', hash, cabinet, domain } as const),
  setIsInIframe: (value: boolean) =>
    ({ type: 'cc/app/SET_IS_IN_IFRAME', value } as const),
  setIsFirstLoadIframe: (value: boolean) =>
    ({ type: 'cc/app/SET_IS_FIRST_LOAD_IFRAME', value } as const),
  setUserCabinets: (arr: CabType[]) =>
    ({ type: 'cc/app/SET_USER_CABINETS', arr } as const),
  setAllCabinets: (arr: CabType[]) =>
    ({ type: 'cc/app/SET_ALL_CABINETS', arr } as const),
  setActualCabinetTitle: (value: string) =>
    ({ type: 'cc/app/SET_ACTUAL_CABINET_TITLE', value } as const),
  setUserCabinetsGridVisibilityModel: (
    model: GridColumnVisibilityModel | undefined
  ) =>
    ({
      type: 'cc/app/SET_USER_CABINETS_GRID_VISIBILITY_MODEL',
      model,
    } as const),
  setUserCabinetsGridSortModel: (model: GridSortModel | undefined) =>
    ({ type: 'cc/app/SET_USER_CABINETS_GRID_SORT_MODEL', model } as const),
  setUserCabinetsGridFilterModel: (model: GridFilterModel | undefined) =>
    ({ type: 'cc/app/SET_USER_CABINETS_GRID_FILTER_MODEL', model } as const),
  setAvailableUsersEmails: (arr: string[]) =>
    ({ type: 'cc/app/SET_AVAILABLE_USERS_EMAILS', arr } as const),
  setCategoriesList: (arr: CategoryType[]) =>
    ({ type: 'cc/app/SET_CATEGORIES_LIST', arr } as const),
  setCategoryGridVisibilityModel: (
    model: GridColumnVisibilityModel | undefined
  ) => ({ type: 'cc/app/SET_CATEGORY_GRID_VISIBILITY_MODEL', model } as const),
  setCategoryGridSortModel: (model: GridSortModel | undefined) =>
    ({ type: 'cc/app/SET_CATEGORY_GRID_SORT_MODEL', model } as const),
  setCategoryGridFilterModel: (model: GridFilterModel | undefined) =>
    ({ type: 'cc/app/SET_CATEGORY_GRID_FILTER_MODEL', model } as const),
  setActiveCategoryId: (value: number) =>
    ({ type: 'cc/app/SET_ACTIVE_CATEGORY_ID', value } as const),
  setActualCabinetCategory: (value: CategoryType | undefined) =>
    ({ type: 'cc/app/SET_ACTUAL_CABINET_CATEGORY', value } as const),
  setMicrovellumName: (value: string) =>
    ({ type: 'cc/app/SET_MICROVELLUM_NAME', value } as const),
  setCostumersList: (arr: CostumerType[]) =>
    ({ type: 'cc/app/SET_COSTUMERS_LIST', arr } as const),
  setCostumerGridVisibilityModel: (
    model: GridColumnVisibilityModel | undefined
  ) => ({ type: 'cc/app/SET_COSTUMER_GRID_VISIBILITY_MODEL', model } as const),
  setCostumerGridSortModel: (model: GridSortModel | undefined) =>
    ({ type: 'cc/app/SET_COSTUMER_GRID_SORT_MODEL', model } as const),
  setCostumerGridFilterModel: (model: GridFilterModel | undefined) =>
    ({ type: 'cc/app/SET_COSTUMER_GRID_FILTER_MODEL', model } as const),
  setRecoveryCodes: (arr: RecoveryCodeType[]) =>
    ({ type: 'cc/app/SET_RECOVERY_CODES', arr } as const),
  setFloorMaterialsList: (arr: FloorMaterialType[]) =>
    ({ type: 'cc/app/SET_FLOOR_MATERIALS_LIST', arr } as const),
  setFloorMaterialGridVisibilityModel: (
    model: GridColumnVisibilityModel | undefined
  ) =>
    ({
      type: 'cc/app/SET_FLOOR_MATERIAL_GRID_VISIBILITY_MODEL',
      model,
    } as const),
  setFloorMaterialGridSortModel: (model: GridSortModel | undefined) =>
    ({ type: 'cc/app/SET_FLOOR_MATERIAL_GRID_SORT_MODEL', model } as const),
  setFloorMaterialGridFilterModel: (model: GridFilterModel | undefined) =>
    ({ type: 'cc/app/SET_FLOOR_MATERIAL_GRID_FILTER_MODEL', model } as const),
  setFMTabAvailable: (value: boolean) =>
    ({ type: 'cc/app/SET_FM_TAB_AVAILABLE', value } as const),
  setDiscountTiersList: (arr: DiscountTierType[]) =>
    ({ type: 'cc/app/SET_DISCOUNT_TIERS_LIST', arr } as const),
}

export type ActionsType = InferActionsType<typeof actions>
type ThunkType = ThunkAction<Promise<void>, StateType, unknown, ActionsType>

export const chooseActualCabinetSizes =
  (setDefaults = true): ThunkType =>
  async (dispatch, getState) => {
    try {
      const cabinetSizes = getState().appReducer.cabinetSizes
      const cornerCabinetSizes = getState().appReducer.cornerCabinetSizes
      const category = getState().appReducer.actualCabinetCategory
      const role = getState().appReducer.user?.role || 'none'
      const cabinetType = getState().cabinetReducer.cabinetType

      const _role =
        role === 'none'
          ? 'retail'
          : role === 'dealer' || role === 'company' || role === 'engineer'
          ? 'dealer'
          : 'designer'

      if (!category && cabinetSizes) {
        // @ts-ignore
        const actualCabinetSizes =
          // @ts-ignore
          cabinetSizes[cabinetType + '_' + _role + '_cabinet_sizes']
        // @ts-ignore
        const actualCornerCabinetSizes =
          // @ts-ignore
          cornerCabinetSizes[cabinetType + '_' + _role + '_cornerCabinet_sizes']

        dispatch(actions.setActualCabinetSizes(actualCabinetSizes))
        dispatch(actions.setActualCornerCabinetSizes(actualCornerCabinetSizes))

        // if (getState().appReducer.gcInfo.hash === '')
        // if (!getState().appReducer.isInIframe)
        //     dispatch(setCabinetSizes(actualCabinetSizes.width.default, actualCabinetSizes.height.default, actualCabinetSizes.depth.default))
      } else if (category) {
        const actualCabinetSizes =
          _role === 'retail'
            ? category.retail
            : _role === 'dealer'
            ? category.dealer
            : category.designer

        if (!category.forCorner)
          dispatch(
            actions.setActualCabinetSizes(
              actualCabinetSizes as CabinetSizesSubType
            )
          )
        else
          dispatch(
            actions.setActualCornerCabinetSizes(
              actualCabinetSizes as CornerCabinetSizesSubType
            )
          )

        // if (setDefaults)
        //     dispatch(setCabinetSizes(actualCabinetSizes.width.default, actualCabinetSizes.height.default, actualCabinetSizes.depth.default))
      }
    } catch (error) {
      console.error((<AxiosError>error).response?.data)
    }
  }

export const getConfigs = (): ThunkType => async (dispatch, getState) => {
  try {
    const configs = clone(getState().appReducer.configs) as ConfigsType

    const descriptions = [] as ConfigDescriptionType[]

    const res = await fetchConfigs()
    for (const config of res) {
      // @ts-ignore
      configs[config.name] = JSON.parse(config.value)
      descriptions.push({
        name: config.name,
        description: config.description,
      })
    }
    // console.log(configs)

    dispatch(actions.setConfigs(configs))
    dispatch(actions.setConfigsDescriptions(descriptions))
    dispatch(actions.setIsConfigsFetched(true))
  } catch (error) {
    console.error((<AxiosError>error).response?.data)
  }
}

export const getCabinetSizes = (): ThunkType => async (dispatch, getState) => {
  try {
    const res = await fetchCabinetSizes()

    const cabinetSizes = {} as CabinetSizesType
    const cornerCabinetSizes = {} as CornerCabinetSizesType

    for (const r of res) {
      if (!r.name.includes('corner')) {
        // @ts-ignore
        cabinetSizes[r.name] = JSON.parse(r.value)
      } else {
        // @ts-ignore
        cornerCabinetSizes[r.name] = JSON.parse(r.value)
      }
    }

    dispatch(actions.setCabinetSizes(cabinetSizes))
    dispatch(actions.setCornerCabinetSizes(cornerCabinetSizes))
    dispatch(chooseActualCabinetSizes())
  } catch (error) {
    console.error((<AxiosError>error).response?.data)
  }
}

export const verifyToken =
  (token: string, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch) => {
    try {
      const user = await me(token)

      dispatch(actions.setToken(token))
      dispatch(actions.setUser(user))
      dispatch(getUserCabinets())
      dispatch(getMaterials())
      dispatch(getFloorMaterials())

      if (user.role === 'admin') {
        dispatch(getUsersInfo(token))
        dispatch(getCostumers())
        dispatch(getRecoveryCodes())
        dispatch(actions.setFMTabAvailable(true))
        dispatch(getDiscountTiers())
      } else if (user.role === 'company' || user.role === 'engineer') {
        dispatch(getCompanyUsersInfo(token))
        if (user.role === 'company') dispatch(getRecoveryCodes())
      } else {
        dispatch(getCompanyUsersEmails(token))
      }

      if (user.refEmail) {
        dispatch(getCompanyInfo(user.refEmail, user.role))
      } else if (user.role === 'company') {
        dispatch(getCompanyInfo(user.email, user.role))
      }

      if (user.email === 'demo@demo.com') {
        dispatch(actions.setIsDemo(true))
      }

      dispatch(chooseActualCabinetSizes())
      showMessage(enqueueSnackbar, 'Welcome back ' + user.name, 'success')
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editUser =
  (user: UserType, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token || ''

      const res = await editUserAPI(token, user)

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Information updated', 'success')
        dispatch(verifyToken(token, enqueueSnackbar))
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editCompanyOfferMarkups =
  (
    companyEmail: string,
    offerMarkups: number[],
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token || ''

      const res = await editCompanyMarkupsAPI(
        token,
        companyEmail,
        offerMarkups.join(';')
      )

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Company Markups updated', 'success')
        dispatch(getUsersInfo(token))
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editCompanyOptions =
  (
    companyEmail: string,
    options: string,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token || ''

      const res = await editCompanyOptionsAPI(token, companyEmail, options)

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Company Options updated', 'success')
        dispatch(getUsersInfo(token))
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const login =
  (
    email: string,
    password: string,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch) => {
    try {
      const { token, user } = await getToken(
        email,
        crypto.createHash('sha256').update(password).digest('hex')
      )

      dispatch(actions.setToken(token))
      dispatch(actions.setUser(user))
      dispatch(getUserCabinets())

      if (user.role === 'admin') {
        dispatch(getUsersInfo(token))
        dispatch(getCostumers())
        dispatch(getRecoveryCodes())
        dispatch(actions.setFMTabAvailable(true))
      } else if (user.role === 'company' || user.role === 'engineer') {
        dispatch(getCompanyUsersInfo(token))
        if (user.role === 'company') dispatch(getRecoveryCodes())
      } else {
        dispatch(getCompanyUsersEmails(token))
      }

      if (user.refEmail) {
        dispatch(getCompanyInfo(user.refEmail, user.role))
      } else if (user.role === 'company') {
        dispatch(getCompanyInfo(user.email, user.role))
      } else {
        dispatch(actions.setCompany(undefined))
      }

      if (user.email === 'demo@demo.com') {
        dispatch(actions.setIsDemo(true))
      }

      dispatch(chooseActualCabinetSizes())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const logout = (): ThunkType => async (dispatch, getState) => {
  try {
    const token = getState().appReducer.token

    if (token) {
      logoutAPI(token)
      dispatch(actions.setToken(undefined))
      dispatch(actions.setUser(undefined))
      // dispatch(actions.setCompany(undefined))
      dispatch(actions.setActiveTab(0))
      dispatch(actions.setRecoveryCodes([]))
    }

    dispatch(chooseActualCabinetSizes())
  } catch (error) {
    // showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
  }
}

export const signup =
  (
    name: string,
    email: string,
    password: string,
    refEmail: string | undefined,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch) => {
    try {
      const res = await createUser(
        name,
        email,
        crypto.createHash('sha256').update(password).digest('hex'),
        refEmail
      )

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Registration is done', 'success')
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const resetPassword =
  (
    code: string,
    password: string,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch) => {
    try {
      const res = await resetPasswordApi(
        code,
        crypto.createHash('sha256').update(password).digest('hex')
      )

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Password was changed', 'success')
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const getCompanyInfo =
  (email: string, userRole: RoleType): ThunkType =>
  async (dispatch) => {
    try {
      const company = await fetchCompanyInfo(email)

      try {
        const options = JSON.parse(company.options)
        const floorMaterialTab = options.floorMaterialTab || '000000'
        dispatch(
          actions.setFMTabAvailable(
            floorMaterialTab[getRoleIndex(userRole)] === '1'
          )
        )
      } catch (error) {
        console.error('INvalid company options string', company.options)
      }

      dispatch(actions.setCompany(company))
      dispatch(actions.setIsCompanyInfoFetched(true))
      dispatch(getCostumers())
    } catch (error) {
      dispatch(actions.setIsCompanyInfoFetched(true))
    }
  }

export const getUsersInfo =
  (token: string): ThunkType =>
  async (dispatch, getState) => {
    try {
      const users = await fetchUsersInfo(token)

      dispatch(actions.setUsersInfo(users))
      dispatch(
        actions.setAvailableUsersEmails(
          users
            .map((u) => u.email)
            .filter((email) => email !== getState().appReducer.user?.email)
        )
      )
    } catch (error) {}
  }

export const getCompanyUsersInfo =
  (token: string): ThunkType =>
  async (dispatch, getState) => {
    try {
      const users = await fetchCompanyUsersInfo(token)

      dispatch(actions.setUsersInfo(users))
      dispatch(
        actions.setAvailableUsersEmails(
          users
            .map((u) => u.email)
            .filter((email) => email !== getState().appReducer.user?.email)
        )
      )
    } catch (error) {}
  }

export const getCompanyUsersEmails =
  (token: string): ThunkType =>
  async (dispatch, getState) => {
    try {
      const emails = await fetchCompanyUsersEmails(token)

      dispatch(
        actions.setAvailableUsersEmails(
          emails.filter((email) => email !== getState().appReducer.user?.email)
        )
      )
    } catch (error) {}
  }

export const setUserRole =
  (
    email: string,
    role: RoleType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const user = getState().appReducer.user
      const token = getState().appReducer.token

      if (user && token) {
        await setUserRoleAPI(token, email, role)

        showMessage(enqueueSnackbar, 'Role Changed', 'success')

        if (user.role === 'company' || user.role === 'engineer') {
          dispatch(getCompanyUsersInfo(token))
        } else if (user.role === 'admin') {
          dispatch(getUsersInfo(token))
        }
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const setUserField =
  (
    email: string,
    fieldName: string,
    fieldValue: string,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const user = getState().appReducer.user
      const token = getState().appReducer.token

      if (user && token) {
        await setUserFieldAPI(token, email, fieldName, fieldValue)

        showMessage(enqueueSnackbar, 'User info Changed', 'success')

        if (user.role === 'company' || user.role === 'engineer') {
          dispatch(getCompanyUsersInfo(token))
        } else if (user.role === 'admin') {
          dispatch(getUsersInfo(token))
        }
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editConfig =
  (
    name: string,
    value: string,
    description: string,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token

      if (token) {
        const res = await editConfigInDB(name, value, description, token)

        if (res === 'OK') {
          showMessage(enqueueSnackbar, 'Config changed', 'success')
          dispatch(getConfigs())
        }
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editCabinetSizes =
  (
    name: string,
    value: string,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token

      if (token) {
        const res = await editCabinetSizesInDB(name, value, token)

        if (res === 'OK') {
          showMessage(enqueueSnackbar, 'Cabinet Sizes changed', 'success')
          dispatch(getCabinetSizes())
        }
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const getUserCabinets = (): ThunkType => async (dispatch, getState) => {
  try {
    const token = getState().appReducer.token || ''
    const role = getState().appReducer.user?.role

    if (token) {
      const cabinets = await fetchUserCabinets(token)
      cabinets.reverse()
      dispatch(actions.setUserCabinets(cabinets))

      if (role === 'admin') {
        const allCabinets = await fetchAllCabinets(token)
        allCabinets.reverse()
        dispatch(actions.setAllCabinets(allCabinets))
      }
    }
  } catch (error) {}
}

export const addCabinet =
  (cabProps: CabPropsType, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token || ''

      const res = await addCabinetToDB(cabProps, token)

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Cabinet saved', 'success')
        dispatch(getUserCabinets())
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editCabinet =
  (
    id: number,
    cabProps: CabPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch) => {
    try {
      await editCabinetInDB(id, cabProps)

      showMessage(enqueueSnackbar, 'Cabinet changed', 'success')
      dispatch(getUserCabinets())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const copyCabinet =
  (id: number, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token || ''
      const cabList = getState().appReducer.userCabinetsList

      const cabinet = cabList.find((c) => c.id === id)

      if (cabinet && token) {
        const { id, ...cabProps } = cabinet

        let title = (cabProps.title += ' Copy')

        if (cabList.find((m) => m.title === title)) {
          let i = 2

          title += '(' + i + ')'
          ;(function func() {
            if (cabList.find((m) => m.title === title)) {
              i++
              title = title.slice(0, -3)
              title += '(' + i + ')'
              func()
            }
          })()
        }

        cabProps.title = title

        const res = await addCabinetToDB(cabProps, token)

        if (res === 'OK') {
          showMessage(enqueueSnackbar, 'Cabinet copied', 'success')
          dispatch(getUserCabinets())
        }
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const deleteCabinet =
  (id: number, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch) => {
    try {
      await deleteCabinetFromDB(id)

      showMessage(enqueueSnackbar, 'Cabinet deleted', 'success')
      dispatch(getUserCabinets())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const shareCabinet =
  (
    cabinetId: number,
    isReference: boolean,
    emails: string[],
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch) => {
    try {
      await shareCabinetInDB(cabinetId, isReference, emails)

      showMessage(enqueueSnackbar, 'Cabinet shared', 'success')
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const getCategories = (): ThunkType => async (dispatch) => {
  try {
    const categoriesAPI = await fetchCategories()
    categoriesAPI.reverse()

    const categories = [] as CategoryType[]

    for (const category of categoriesAPI) {
      categories.push({
        id: category.id,
        date: category.date,
        name: category.name,
        displayName: category.displayName,
        forCorner: category.forCorner === '0' ? false : true,
        retail: JSON.parse(category.retail),
        dealer: JSON.parse(category.dealer),
        designer: JSON.parse(category.designer),
      })
    }

    dispatch(actions.setCategoriesList(categories))
    dispatch(actions.setIsDataFetched(true))
  } catch (error) {}
}

export const addCategory =
  (
    categoryProps: CategoryPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token || ''

      const res = await addCategoryToDB(
        {
          name: categoryProps.name,
          displayName: categoryProps.displayName,
          forCorner: categoryProps.forCorner ? '1' : '0',
          retail: JSON.stringify(categoryProps.retail),
          dealer: JSON.stringify(categoryProps.dealer),
          designer: JSON.stringify(categoryProps.designer),
        },
        token
      )

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Category saved', 'success')
        dispatch(getCategories())
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editCategory =
  (
    id: number,
    categoryProps: CategoryPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token || ''

      await editCategoryInDB(
        id,
        {
          name: categoryProps.name,
          displayName: categoryProps.displayName,
          forCorner: categoryProps.forCorner ? '1' : '0',
          retail: JSON.stringify(categoryProps.retail),
          dealer: JSON.stringify(categoryProps.dealer),
          designer: JSON.stringify(categoryProps.designer),
        },
        token
      )

      showMessage(enqueueSnackbar, 'Category changed', 'success')
      dispatch(getCategories())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const copyCategory =
  (id: number, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token || ''
      const categoryList = getState().appReducer.categoriesList

      const category = categoryList.find((c) => c.id === id)

      if (category && token) {
        const { id, ...categoryProps } = category

        let name = (categoryProps.name += ' Copy')

        if (categoryList.find((m) => m.name === name)) {
          let i = 2

          name += '(' + i + ')'
          ;(function func() {
            if (categoryList.find((m) => m.name === name)) {
              i++
              name = name.slice(0, -3)
              name += '(' + i + ')'
              func()
            }
          })()
        }

        categoryProps.name = name

        const res = await addCategoryToDB(
          {
            name: categoryProps.name,
            displayName: categoryProps.displayName,
            forCorner: categoryProps.forCorner ? '1' : '0',
            retail: JSON.stringify(categoryProps.retail),
            dealer: JSON.stringify(categoryProps.dealer),
            designer: JSON.stringify(categoryProps.designer),
          },
          token
        )

        if (res === 'OK') {
          showMessage(enqueueSnackbar, 'Cabinet copied', 'success')
          dispatch(getCategories())
        }
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const deleteCategory =
  (id: number, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch, getState) => {
    try {
      await deleteCategoryFromDB(id)

      showMessage(enqueueSnackbar, 'Category deleted', 'success')
      dispatch(getCategories())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const getCostumers = (): ThunkType => async (dispatch, getState) => {
  try {
    const user = getState().appReducer.user
    const company = getState().appReducer.company
    const token = getState().appReducer.token || ''

    if (!user) return

    if (user.role === 'admin') {
      const costumers = await fetchAllCostumers(token)
      dispatch(actions.setCostumersList(costumers))

      return
    }

    if (!company || user.role === 'none') return

    const costumers = await fetchCostumers(company.email)

    if (user.role === 'company' || user.role === 'engineer') {
      //company owner and engineer
      dispatch(actions.setCostumersList(costumers))
    } else {
      // company employee (designer)
      dispatch(
        actions.setCostumersList(
          costumers.filter((costumer) => costumer.creatorEmail === user.email)
        )
      )
    }
  } catch (error) {}
}

export const addCostumer =
  (
    costumerProps: CostumerPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const user = getState().appReducer.user
      const company = getState().appReducer.company

      if (!user) return

      costumerProps.creatorEmail = user.email

      if (user.role === 'admin') {
        costumerProps.companyEmail = '_'
      } else if (!company || user.role === 'none') return
      else {
        //company
        costumerProps.companyEmail = company.email
      }

      const res = await addCostumerToDB(costumerProps)

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Costumer saved', 'success')
        dispatch(getCostumers())
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editCostumer =
  (
    id: number,
    costumerProps: CostumerPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      // const token = getState().appReducer.token || ''

      await editCostumerInDB(id, costumerProps)

      showMessage(enqueueSnackbar, 'Costumer changed', 'success')
      dispatch(getCostumers())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const deleteCostumer =
  (id: number, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch, getState) => {
    try {
      await deleteCostumerFromDB(id)

      showMessage(enqueueSnackbar, 'Costumer deleted', 'success')
      dispatch(getCostumers())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const generateRecoveryCode =
  (userEmail: string, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch, getState) => {
    try {
      const token = getState().appReducer.token || ''

      const code = Math.random().toString().slice(2, 10)

      await generateRecoveryCodeApi(userEmail, token, code)

      dispatch(getRecoveryCodes())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const getRecoveryCodes = (): ThunkType => async (dispatch, getState) => {
  try {
    const token = getState().appReducer.token || ''

    const codes = await fetchRecoveryCodes(token)

    dispatch(actions.setRecoveryCodes(codes))
  } catch (error) {
    console.error(error)
  }
}

export const getFloorMaterials =
  (): ThunkType => async (dispatch, getState) => {
    try {
      const user = getState().appReducer.user
      const company = getState().appReducer.company
      // const materials = getState().itemReducer.materials.filter(m => m.type === 'floor')

      // const distributors = new Set()
      // const availableMaterialsForFM = []

      // for (const material of materials) {
      //     distributors.add(material.distributorCompany)
      // }

      // console.log(distributors);

      if (!user) return

      let fms = await fetchFloorMaterials()
      fms.reverse()

      if (user.role === 'admin') {
        // pass, show all fms
      } else if (!company || user.role === 'none') return
      else {
        //company
        const dealerId = company.ownerId.toString()

        fms = fms.filter((fm) => fm.dealerId.split(',').includes(dealerId))
      }

      dispatch(actions.setFloorMaterialsList(fms))
    } catch (error) {}
  }

export const addFloorMaterial =
  (
    fmProps: FloorMaterialPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const user = getState().appReducer.user
      const company = getState().appReducer.company

      if (!user) return

      if (user.role === 'admin') {
        fmProps.dealerId = ''
      } else if (!company || user.role === 'none') return
      else {
        //company
        fmProps.dealerId = company.ownerId.toString()
      }

      const res = await addFloorMaterialToDB(fmProps)

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Floor Material added', 'success')
        dispatch(getFloorMaterials())
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editFloorMaterial =
  (
    id: number,
    fmProps: FloorMaterialPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch) => {
    try {
      await editFloorMaterialInDB(id, fmProps)

      showMessage(enqueueSnackbar, 'Floor Material changed', 'success')

      dispatch(getFloorMaterials())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const getDiscountTiers = (): ThunkType => async (dispatch, getState) => {
  try {
    const user = getState().appReducer.user

    if (!user || user.role !== 'admin') return

    let tiers = await fetchDiscountTiers()
    tiers.reverse()

    dispatch(actions.setDiscountTiersList(tiers))
  } catch (error) {}
}

export const addDiscountTier =
  (
    tierProps: DiscountTierPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const user = getState().appReducer.user

      if (!user || user.role !== 'admin') return

      const res = await addDiscountTierToDB(tierProps)

      if (res === 'OK') {
        showMessage(enqueueSnackbar, 'Discount tier added', 'success')
        dispatch(getDiscountTiers())
      }
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const editDiscountTier =
  (
    id: number,
    tierProps: DiscountTierPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): ThunkType =>
  async (dispatch, getState) => {
    try {
      const user = getState().appReducer.user

      if (!user || user.role !== 'admin') return

      await editDiscountTierInDB(id, tierProps)

      showMessage(enqueueSnackbar, 'Discount tier changed', 'success')

      dispatch(getDiscountTiers())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export const deleteDiscountTier =
  (id: number, enqueueSnackbar: EnqueueSnackbarType): ThunkType =>
  async (dispatch, getState) => {
    try {
      const user = getState().appReducer.user

      if (!user || user.role !== 'admin') return

      await deleteDiscountTierFromDB(id)

      showMessage(enqueueSnackbar, 'Discount tier deleted', 'success')

      dispatch(getDiscountTiers())
    } catch (error) {
      showMessage(enqueueSnackbar, (<AxiosError>error).response?.data)
    }
  }

export default appReducer
